<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px">
      <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" style="border-bottom: 1px solid #ccc" />
      <Editor
        :defaultConfig="computedEditorConfig"
        :mode="mode"
        :modelValue="modelValue"
        style="height: 200px; overflow-y: hidden"
        @onCreated="handleCreated"
        @onChange="handleChange"
        @update:modelValue="$emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import '@wangeditor/editor/dist/css/style.css'
import { onBeforeUnmount, ref, shallowRef, watch, computed } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { uploadForEditor } from './editorUpload'
// @ts-ignore
import { Message } from '@zto/zpage-ui-element'
// @ts-ignore
import { useCurrentAppInstance } from '@zto/zpage'

export default {
  components: { Editor, Toolbar },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    toolbarConfig: {
      type: Object,
      default: () => ({
        excludeKeys: [
          'emotion',
          'insertLink',
          'insertImage',
          'group-video',
          'insertTable',
          'undo',
          'redo',
          'codeBlock',
          'group-more-style',
          'blockquote',
          'fontFamily',
          'lineHeight',
          'divider',
          'fullScreen',
          'todo'
        ]
      })
    },
    editorConfig: {
      type: Object,
      default: () => ({
        placeholder: '请输入内容...'
      })
    }
  },
  emits: ['update:modelValue', 'change', 'created', 'destroyed', 'focus', 'blur'],
  setup(props, { emit }) {
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef()
    const mode = ref('default')
    
    // 获取应用实例
    const app = useCurrentAppInstance()

    // 计算编辑器配置
    const computedEditorConfig = computed(() => ({
      ...props.editorConfig,
      MENU_CONF: {
        ...(props.editorConfig.MENU_CONF || {}),
        uploadImage: {
          async customUpload(file: any, insertFn: any) {
            try {
              const url: string = await uploadForEditor(file, app, {
                storePath: 'richtext/',
                storeGroup: 'public'
              })
              insertFn(url, '图片', url)
            } catch (error) {
              const msg: any = error?.message || error || '上传图片失败'
              Message.error(msg)
              console.log(error)
            }
          }
        }
      }
    }))

    // 初始化编辑器
    const handleCreated = (editor: any) => {
      editorRef.value = editor
      emit('created', editor)
    }

    // 内容变化处理
    const handleChange = (editor: any) => {
      const html = editor.getHtml()
      emit('update:modelValue', html)
      emit('change', html)
    }

    // 监听外部内容变化
    watch(
      () => props.modelValue,
      newVal => {
        if (!editorRef.value) return
        if (newVal !== editorRef.value.getHtml()) {
          editorRef.value.setHtml(newVal)
        }
      }
    )

    // 组件销毁处理
    onBeforeUnmount(() => {
      if (!editorRef.value) return
      editorRef.value.destroy()
      emit('destroyed')
    })

    return {
      editorRef,
      mode,
      computedEditorConfig,
      handleCreated,
      handleChange
    }
  }
}
</script>
